import { createSelector } from 'reselect';
import _ from 'lodash';
import { getFormValues, formValueSelector } from 'redux-form';

import { RecipePreparationFiltersEnum as FilterFields } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import {
  RECIPE_PREPARATION_FILTERS_FORM_NAME,
  RECIPE_PREPARATION_TABLE_FORM_NAME,
} from 'Common/FormEnum';

const root = state => _.get(state, 'RecipePreparationState');

export const getCycleMenus = state => _.get(root(state), 'cycleMenus', []);

export const getLoading = state => _.get(root(state), 'loading', false);

export const getError = state => _.get(root(state), 'error', null);

export const getCycleMenuOptions = createSelector(
  getCycleMenus,
  cycleMenus => makeOptionsData(cycleMenus)
);

export const getFilterValues = getFormValues(
  RECIPE_PREPARATION_FILTERS_FORM_NAME
);

const filterValuesSelector = formValueSelector(
  RECIPE_PREPARATION_FILTERS_FORM_NAME
);
export const getTabIndex = state =>
  filterValuesSelector(state, FilterFields.Tab);

const recPrepSelector = formValueSelector(RECIPE_PREPARATION_TABLE_FORM_NAME);

export const getRecipes = state => recPrepSelector(state, 'Recipes') || [];

export const getAllSelected = createSelector(
  getRecipes,
  recipes =>
    Array.isArray(recipes) &&
    recipes.length > 0 &&
    recipes.every(r => r.Selected)
);

export const getHasSelected = createSelector(
  getRecipes,
  recipes => recipes.filter(r => r.Selected).length > 0
);

export const getIndeterminate = createSelector(
  getRecipes,
  getHasSelected,
  (recipes, hasSelected) => {
    const numSelected = recipes.filter(r => r.Selected).length;
    return hasSelected && numSelected !== recipes.length;
  }
);



// WEBPACK FOOTER //
// ./src/pages/recipepreparation/state/selectors.js